import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

export const business = createReducer(
  {
    info: {},
    status: {},
    phoneList: {},
    details: {},
    staffById: {},
    serviceById: {},
    clientUser: {},
    locations: {},
    conversation_locations: [],
    selectedLocation: {},
    getBusinessDetails: false,
    businessDetailsFetched: false,
    updatingBusinessName: false,
    updateBusinessNameSuccess: false,
    studioName: '',
  },
  {
    [types.GET_BUSINESS_START](state) {
      const newState = Object.assign({}, state, {
        isInfoFetched: false,
        info: {},
      });

      return newState;
    },
    [types.GET_BUSINESS_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        isInfoFetched: true,
        info: { ...state.info, ...action.business },
      });

      return newState;
    },
    [types.GET_BUSINESS_ID_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        id: action.businessId.data.id,
      });
      return newState;
    },
    [types.GET_BUSINESS_FAIL](state) {
      const newState = Object.assign({}, state, {
        isInfoFetched: false,
        info: {},
      });

      return newState;
    },
    [types.GET_BUSINESS_STATUS_START](state) {
      const newState = Object.assign({}, state, {
        status: {},
      });

      return newState;
    },
    [types.GET_USER_SUCCESS](state, action) {
      const { info } = state;
      const clientUser = action.user;
      if (state.info && state.info.BUSINESS_NAME) {
        // All good - Do nothing
      } else {
        info.BUSINESS_NAME = action.user.business_name;
      }

      return { ...state, info, clientUser };
    },
    [types.GET_BUSINESS_STATUS_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        status: action.status,
      });

      return newState;
    },
    [types.GET_BUSINESS_STATUS_FAIL](state) {
      const newState = Object.assign({}, state, {
        status: {
          isSetup: false,
        },
      });

      return newState;
    },
    [types.GET_PHONE_LIST_SUCCESS](state, action) {
      const newPhoneList = {};
      for (let i = 0, l = action.phoneList.length; i < l; i += 1) {
        newPhoneList[action.phoneList[i].phoneNum] = action.phoneList[i];
      }
      const newState = Object.assign({}, state, {
        phoneList: newPhoneList,
      });

      return newState;
    },
    [types.GET_PHONE_LIST_FAIL](state) {
      const newState = Object.assign({}, state, {
        phoneList: {},
      });

      return newState;
    },
    [types.ADD_PHONE_NUMBER_START](state) {
      const newState = Object.assign({}, state, {
        isPhoneAdded: null,
        isPhoneAddInProgress: true,
      });

      return newState;
    },
    [types.ADD_PHONE_NUMBER_SUCCESS](state, action) {
      const newPhoneList = Object.assign({}, state.phoneList, {
        [action.phoneNumber]: {
          phoneNum: action.phoneNumber,
          status: action.status ? 'VERIFIED' : 'UNVERIFIED',
        },
      });

      const newState = Object.assign({}, state, {
        phoneList: newPhoneList,
        isPhoneAdded: action.status,
        isPhoneAddInProgress: false,
      });

      return newState;
    },
    [types.ADD_PHONE_NUMBER_FAIL](state) {
      const newState = Object.assign({}, state, {
        isPhoneAdded: false,
        isPhoneAddInProgress: false,
      });

      return newState;
    },
    [types.REMOVE_PHONE_NUMBER_START](state) {
      const newState = Object.assign({}, state, {
        isPhoneRemoved: null,
      });

      return newState;
    },
    [types.REMOVE_PHONE_NUMBER_SUCCESS](state, action) {
      const newPhoneList = Object.assign({}, state.phoneList);
      delete newPhoneList[action.phoneNumber];

      const newState = Object.assign({}, state, {
        phoneList: newPhoneList,
        isPhoneRemoved: true,
      });

      return newState;
    },
    [types.REMOVE_PHONE_NUMBER_FAIL](state) {
      const newState = Object.assign({}, state, {
        isPhoneRemoved: false,
      });

      return newState;
    },
    [types.SEND_NOTIFICATION_START](state) {
      const newState = Object.assign({}, state, {
        isNotificationSent: null,
      });

      return newState;
    },
    [types.SEND_NOTIFICATION_SUCCESS](state) {
      const newState = Object.assign({}, state, {
        isNotificationSent: true,
      });

      return newState;
    },
    [types.SEND_NOTIFICATION_FAIL](state) {
      const newState = Object.assign({}, state, {
        isNotificationSent: false,
      });

      return newState;
    },
    [types.GET_BUSINESS_DETAILS_START](state) {
      return { ...state, getBusinessDetails: true };
    },
    // Business details from TC API
    [types.GET_BUSINESS_DETAILS_SUCCESS](state, action) {
      const staffById = {};
      const serviceById = {};
      for (let i = 0, l = action.data.staffs.length; i < l; i += 1) {
        staffById[action.data.staffs[i].id] = action.data.staffs[i];
      }
      for (let i = 0, l = action.data.services.length; i < l; i += 1) {
        serviceById[action.data.services[i].id] = action.data.services[i];
      }
      return {
        ...state,
        getBusinessDetails: false,
        businessDetailsFetched: true,
        details: action.data,
        staffById,
        serviceById,
      };
    },
    [types.GET_BUSINESS_DETAILS_FAIL](state) {
      return {
        ...state,
        getBusinessDetails: false,
        details: {},
        staffById: {},
        serviceById: {},
      };
    },
    [types.GET_BUSINESS_LOCATIONS_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        ...(action.typeofaccess === 'DASHBOARD_ACCESS' && {
          locations: action.data,
        }),
        ...(action.typeofaccess === 'CONVERSATION_ACCESS' && {
          conversation_locations: action.data,
        }),
        isLocationfetchsuccess: true,
        ...(action.data.length === 1 && { selectedLocation: action.data[0] }),
      });

      return newState;
    },
    [types.GET_BUSINESS_LOCATIONS_FAIL](state) {
      const newState = Object.assign({}, state, {
        isLocationfetchsuccess: false,
      });
      return newState;
    },
    [types.SET_SELECTED_LOCATION](state, action) {
      const newState = Object.assign({}, state, {
        selectedLocation: action.location,
      });

      return newState;
    },
    [types.UPDATE_BUSINESS_NAME_START](state) {
      const newState = Object.assign({}, state, {
        updatingBusinessName: true,
      });

      return newState;
    },
    [types.UPDATE_BUSINESS_NAME_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        updatingBusinessName: false,
        updateBusinessNameSuccess: true,
        studioName: action.studioName,
      });

      return newState;
    },
    [types.UPDATE_BUSINESS_NAME_FAIL](state) {
      const newState = Object.assign({}, state, {
        updatingBusinessName: false,
        updateBusinessNameSuccess: false,
      });
      return newState;
    },
  },
);

export { business as default };
